<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">GGC LOAN REMITTANCES</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap class="align-center mx-2 mt-5">
        <v-layout col>
          <v-flex xs12 md5>
            <v-form ref="form" class="multi-col-validation">
              <v-select
                v-model="month_of_id"
                class="mx-2"
                dense
                outlined
                label="Month Of"
                :items="month_of_items"
                item-value="month_of"
                item-text="month_of"
                :rules="rules.combobox_rule"
                @change="selected_data"
              ></v-select>
              <v-col cols="12" v-show="alert">
                <v-alert
                  color="warning"
                  text
                  class="mb-0"

                >
                  <div class="d-flex align-start">
                    <v-icon color="warning">
                      {{ icons.mdiAlertOutline }}
                    </v-icon>

                    <div class="ms-3">
                      <p class="text-base font-weight-medium mb-1">
                        {{alert_message}}
                      </p>
                    </div>
                  </div>
                </v-alert>
              </v-col>
<!--              <v-col cols="12" md="12"-->
<!--                     v-if="data_items.length>0">-->
<!--                <v-btn-->
<!--                  class="w-full"-->
<!--                  color="primary"-->
<!--                  @click="print_data()"-->
<!--                  v-if="!saving_data"-->
<!--                >-->
<!--                  Print-->
<!--                </v-btn>-->
<!--                <v-progress-circular-->
<!--                  :size=50-->
<!--                  :width="5"-->
<!--                  color="primary"-->
<!--                  indeterminate-->
<!--                  v-else-->
<!--                ></v-progress-circular>-->
<!--              </v-col>-->
            </v-form>
            <v-data-table dense
                          :headers="headers3"
                          :items="data_items"
            >
              <template v-slot:item="{ item }">
                <tr
                  @click="activerow(item)"
                  :class="{'info white--text': item.id===selectedDepositId}"
                >
                  <td>
                    {{ item.id }}
                  </td>
                  <td>
                    {{ item.date_of_deposit }}
                  </td>
                  <td>
                    {{ item.time_of_deposit }}
                  </td>
                  <td>
                    {{ item.bank_depositories!=null?item.bank_depositories.bank_code:'' }}
                  </td>
                  <td>
                    {{ formatPrice(item.amount) }}
                  </td>
                  <td>
                    {{ formatPrice(item.balance) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 md7 class="mx-2">
            <h2>Total: P {{total_amount}}</h2>
            <v-data-table dense
                          :headers="headers2"
                          :items="data_items2"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title v-if="!printingss && data_items2.length > 0">Print
                  </v-toolbar-title>
                  <v-icon
                    v-if="!printingss && data_items2.length > 0"
                    color="success"
                    @click="print_data()"
                  >
                    {{ icons.mdiPrinter }}
                  </v-icon>
                  <v-progress-circular
                    color="info"
                    indeterminate
                    v-if="printingss"
                  ></v-progress-circular>
                </v-toolbar>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td>
                    {{ item.name }}
                  </td>
                  <td>
                    {{ item.type }}
                  </td>
                  <td>
                    {{ item.invoice_no }}
                  </td>
                  <td>
                    {{ formatPrice(item.amount) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card>
    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
  import {
    mdiAccountOutline,
    mdiAccountCashOutline,
    mdiInformationOutline,
    mdiPrinter
  } from "@mdi/js";
  import moment from "moment";
  import {mapActions, mapGetters} from "vuex";
  import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'
  import category from "@/store/module/data/category";

  const initialState = () => {
    return {
      alert: false,
      saving_data: false,
      printingss: false,
      alert_message: '',
      month_of_id: '',
      view_by: '',
      total_amount: '0',
      headers2: [
        {text: 'Name', value: 'date_of_deposit', sortable: false},
        {text: 'Type', value: 'type', sortable: false},
        {text: 'Invoice #', value: 'invoice_no', sortable: false},
        {text: 'Amount', value: 'tin', sortable: false},
      ],
      headers3: [
        {text: 'ID', value: 'id', sortable: false},
        {text: 'Date', value: 'date_of_deposit', sortable: false},
        {text: 'Time', value: 'tin', sortable: false},
        {text: 'Bank', value: 'tin', sortable: false},
        {text: 'Amount', value: 'tin', sortable: false},
        {text: 'Balance', value: 'tin', sortable: false},
      ],
      data_items: [],
      data_items2: [],
      month_of_items: [],
      selectedDepositId: -1,
      current_page: '',
      remittances_category: '',
      depo_info: {},
    }
  }
  export default {
    components: {
      snackBarDialog,
    },
    setup() {
      return {
        icons: {
          mdiAccountOutline,
          mdiAccountCashOutline,
          mdiPrinter,
          mdiInformationOutline,
        },
      }
    },
    data() {
      return initialState()
    },
    mounted() {
      this.initialize_salaries_employee()
        .then(response => {
          this.month_of_items = response.data[0].month_of
        })
        .catch(error => {
          console.log(error)
        })
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
      ...mapGetters('authentication', ['address', 'contact', 'name', 'department', 'position']),
      ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo', 'damayan', 'chapel', 'factory', 'coop', 'printing']),
    },
    methods: {
      ...mapActions('system_data', ['change_snackbar']),
      ...mapActions('salaries_and_wages', ['initialize_salaries_employee',]),
      ...mapActions('ggc_loan_deposit_slips', ['view_ggc_loan_remittances',]),
      date_format(value) {
        return moment(value)
      },
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      selected_data() {
        this.selectedDepositId = -1
        this.data_items = []
        this.data_items2 = []
        this.total_amount = '0'
        this.view_ggc_loan_remittances({
          view_by: this.view_by,
          month_of_id: this.month_of_id
        })
          .then(response => {
            this.data_items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      activerow(value) {
        this.depo_info = value
        this.total_amount = '0'
        this.data_items2 = []
        this.selectedDepositId = value.id;
        var tto = 0;
        var dedd = [];
        if (value.payment.length > 0) {
          value.payment.forEach(function (item) {
            var amm=((parseFloat(item.amount)+parseFloat(item.interest)+parseFloat(item.penalty)-parseFloat(item.ca)));
            dedd.push({name: item.loan_data.name, type: 'LOAN PAYMENT',invoice_no:item.or_no, amount:amm })
            tto += parseFloat(amm)
          });
        }
        if (value.deduction_payment.length > 0) {
          value.deduction_payment.forEach(function (item) {
            dedd.push({name: item.loan_data.name, type: item.particulars,invoice_no:'N/A', amount: item.amount})
            tto += parseFloat(item.amount)
          });
        }
        this.data_items2 = dedd
        this.total_amount = this.formatPrice(tto)
      },
      print_data() {
        this.saving_data = true
        this.alert = false
        if (this.$refs.form.validate()) {
          var imgData = this.company_logo
          var payments_array = []
          var widths = []
          var payment = 0
          var info_array = []

          widths = [200, 100,50, 60]
          payments_array.push([
            {text: 'Name', alignment: 'left', style: 'main_info',},
            {text: 'Type', alignment: 'left', style: 'main_info'},
            {text: 'Invoice#', alignment: 'left', style: 'main_info'},
            {text: 'Amount', alignment: 'left', style: 'main_info'},
          ])
          this.data_items2.forEach(function (item) {
            payment += parseFloat(item.amount)
            payments_array.push([
              {
                text: item.name,
                alignment: 'left',
                style: 'tableExample2'
              },
              {
                text: item.type,
                alignment: 'left',
                style: 'tableExample2'
              },
              {
                text: item.invoice_no,
                alignment: 'left',
                style: 'tableExample2'
              },
              {
                text: (item.amount / 1)
                  .toFixed(2)
                  .replace(',', '.')
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                alignment: 'left',
                style: 'tableExample2'
              },
            ])
          })
          info_array = [
            {
              columns: [
                {
                  style: 'main_info',
                  text: [
                    'Month of: ',
                    {
                      text: this.month_of_id,
                      style: 'main_data',
                    },
                  ],
                },
              ],
            },
            {
              columns: [
                {
                  style: 'main_info',
                  text: [
                    'Deposit ID: ',
                    {
                      text: this.depo_info.id,
                      style: 'main_data', color: 'red',
                    },
                  ],
                },
              ],
            },
            {
              columns: [
                {
                  style: 'main_info',
                  text: [
                    'Date Deposited: ',
                    {
                      text: this.depo_info.date_of_deposit,
                      style: 'main_data',
                    },
                  ],
                },
                {text: ''},
                {
                  style: 'main_info',
                  text: [
                    'Bank: ',
                    {
                      text: this.depo_info.bank_depositories.bank_code,
                      style: 'main_data',
                    },
                  ],
                },
              ],
            },
            {
              columns: [
                {
                  style: 'main_info',
                  text: [
                    'Time Deposited: ',
                    {
                      text: this.depo_info.time_of_deposit,
                      style: 'main_data',
                    },
                  ],
                },
                {text: ''},
                {
                  style: 'main_info',
                  text: [
                    'Amount: ',
                    {
                      text: this.formatPrice(this.depo_info.amount),
                      style: 'main_data', color: 'green',
                    },
                  ],
                },
              ],
            },
            {
              columns: [
                {text: ''},
                {text: ''},
                {
                  style: 'main_info',
                  text: [
                    'Dep. Balance: ',
                    {
                      text: this.formatPrice(this.depo_info.balance),
                      style: 'main_data', color: 'red',
                    },
                  ],
                },
              ],
            },
          ]

          //call pdfmake
          var pdfMake = require('pdfmake/build/pdfmake.js')
          if (pdfMake.vfs == undefined) {
            var pdfFonts = require('pdfmake/build/vfs_fonts.js')
            pdfMake.vfs = pdfFonts.pdfMake.vfs
          }
          var docDefinition = {
            pageSize: {
              width: 612,
              height: 936,
            },
            pageOrientation: 'portrait',
            content: [
              {
                columns: [
                  {image: imgData, width: 54, height: 54, style: 'logo'},
                  {
                    stack: [
                      'GOODLIFE GROUP OF COMPANIES',
                      {text: this.address, style: 'subheader'},
                      {
                        text: this.contact,
                        style: 'subheader',
                      },
                      {
                        text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                        style: 'printed_label',
                      },
                    ],
                    style: 'header',
                  },
                ],
              },
              '_______________________________________________________________________________________________',
              {
                stack: [
                  {
                    columns: [
                      {
                        text: 'REMITTANCES OF - GGC LOAN',
                        style: {
                          fontSize: 16,
                          alignment: 'center',
                          bold: true,
                          color: 'blue',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                columns: [{text: ' '}],
              },
              {
                columns: [{text: ' '}],
              },
              {
                stack: info_array,
              },
              {
                columns: [{text: ' '}],
              },
              {
                table: {
                  widths: widths,
                  body: payments_array,
                  style: {fontSize: 1},
                },
              },
              {
                stack: [
                  {
                    columns: [{text: ' '}],
                  },
                  {
                    columns: [{text: ' '}],
                  },
                  {
                    columns: [
                      {
                        text: 'PROCESSED BY',
                        style: 'main_data_2',
                      },
                      {
                        text: 'DEPARTMENT RECEIVER',
                        style: 'main_data_2',
                      },
                      {
                        text: 'RECEIVED BY',
                        style: 'main_data_2',
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: this.name,
                        style: 'main_data_2',
                      },
                      {
                        text: ' ',
                      },
                      {
                        text: '',
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: '_____________________',
                      },
                      {
                        text: '_____________________',
                      },
                      {
                        text: '_____________________',
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: this.position,
                        style: 'main_data_2',
                      },
                      {
                        text: 'Signature Over Printed Name',
                        style: 'main_data_2',
                      },
                      {
                        text: 'Signature Over Printed Name',
                        style: 'main_data_2',
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: 'VERIFIED BY',
                        style: 'main_data_2',
                      },
                      {
                        text: '',
                      },
                      {
                        text: '',
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: '_________________________________________',
                      },
                      {
                        text: ' ',
                      },
                      {
                        text: ' ',
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: 'BOARD OF DIRECTOR',
                        style: 'main_data_2',
                      },
                      {
                        text: '',
                      },
                      {
                        text: '',
                      },
                    ],
                  },
                ],
              },
              {
                columns: [
                  {image: this.damayan, width: 54, height: 40, style: 'logo'},
                  {image: this.chapel, width: 54, height: 40, style: 'logo'},
                  {image: this.factory, width: 54, height: 40, style: 'logo'},
                  {image: this.coop, width: 54, height: 40, style: 'logo'},
                  {image: this.printing, width: 54, height: 40, style: 'logo'},
                ],
              },
            ],
            footer: {
              // columns: [
              //     {
              //         text: 'Generated with Goodlife Savings & Credit Cooperative System',
              //         alignment: 'center',
              //         style: 'tableExample'
              //     }
              // ]
            },
            styles: {
              tableExample: {
                fontSize: 9,
              },
              tableExample2: {
                fontSize: 7,
              },
              header: {
                fontSize: 21,
                bold: true,
                alignment: 'left',
                margin: [6, 6, 0, 5], //[left, top, right, bottom]
              },
              subheader: {
                fontSize: 11,
              },
              logo: {
                alignment: 'center',
                margin: [0, 0, 0, 0], //[left, top, right, bottom]
              },
              printed_label: {
                alignment: 'right',
                fontSize: 9,
                margin: [0, 0, 0, 0], //[left, top, right, bottom]
              },
              main_data: {
                margin: [0, 2, 0, 2],
                fontSize: 11,
                bold: true,
                alignment: 'left',
              },
              main_data_2: {
                margin: [0, 2, 0, 2],
                fontSize: 8,
                bold: true,
                alignment: 'left',
              },
              main_info: {
                margin: [0, 2, 0, 2],
                fontSize: 10,
                alignment: 'left',
              },
            },
          }
          pdfMake.createPdf(docDefinition).open()
          this.saving_data = false
        } else {
          this.alert = true
          this.alert_message = 'Please Fill up the field/s'
          this.saving_data = false
        }
      }
    }
  }
</script>
